function QuoteEntry({
  id,
  text,
  context,
  onQuoteChange,
  onContextChange,
  onRemove,
  showRemoveButton,
  index,
}) {
  return (
    <div className="quote-entry">
      <label htmlFor={`quote-${id}`}>Quote {index + 1}:</label>

      <textarea
        id={`quote-${id}`}
        rows="3"
        value={text}
        onChange={(e) => onQuoteChange(id, e.target.value)}
        placeholder="Enter quote here"
      ></textarea>

      <label htmlFor={`context-${id}`}>Context:</label>
      <input
        type="text"
        id={`context-${id}`}
        value={context || ""}
        onChange={(e) => onContextChange(id, e.target.value)}
        placeholder="e.g., in a paragraph about..., in a section about..., after a section about..."
      />

      {showRemoveButton && (
        <button
          type="button"
          className="remove-quote-btn"
          onClick={() => onRemove(id)}
          aria-label={`Remove quote ${index + 1}`}
        >
          <i className="fas fa-times"></i>
        </button>
      )}
    </div>
  );
}

export default QuoteEntry;
